/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Input, Injectable } from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Property} from "../models/property";
import {LocationService} from "../services/location.service";
import {PropertyDescription} from "../models/propertyDescription";

@Injectable()
export class LocationParametersResolver implements Resolve<PropertyDescription[]> {

  constructor(
    private mLocationService: LocationService
) {}

async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<PropertyDescription[]> {
  try {
    const functionParameters = [];

  //const locations = await this.mLocationService.getAllLocations();
  //if (locations) {
  //  for (const location of locations) {
  //    // Grab individual object - as the list itself does not contain the properties
  //    const locationWithProperties = await this.mLocationService.getLocationById(location.id);
  //    if (locationWithProperties.properties && locationWithProperties.properties.length > 0) {
  //      for (const property of locationWithProperties.properties) {
  //        const propertyDescription = new PropertyDescription();
  //        propertyDescription.parentName = locationWithProperties.name;
  //        propertyDescription.name = property.name;
  //        functionParameters.push(propertyDescription);
  //      }
  //    }
  //  }
  //} else {
  //  console.error("Locations empty");
  //}
  return functionParameters;    } catch (error) {
    console.error("Problem resolving Locations... Error: " + error, error);
  }
}

}
